import { Box } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { SoftReceivedGoodsReceiptFormValues } from "../../schemas"

import { FormNumericField } from "@/components/UiKit/FormControls/FormNumericField"
import { FormTextField } from "@/components/UiKit/FormControls/FormTextField"
import { HOLD_AREA_1 } from "@/constants/warehouse"
import { TrackingNumbersFields } from "@/screens/WarehouseReceiving/components"

export const SoftReceivedGoodsReceiptForm: FC = () => {
  const { control } = useFormContext<SoftReceivedGoodsReceiptFormValues>()

  return (
    <Box className='flex flex-col gap-4'>
      <TrackingNumbersFields />

      <FormTextField control={control} name='destination' label='Destination' placeholder={HOLD_AREA_1} disabled />

      <FormNumericField
        control={control}
        name='palletQtyDelivered'
        label='Pallet Qty Delivered'
        placeholder='Enter number of pallets delivered'
        required
      />

      <FormNumericField
        control={control}
        name='spacesUsed'
        label='Spaces Used'
        placeholder='Enter number of spaces used'
      />
    </Box>
  )
}
